import React from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuthActions from "../../../api/hooks/admin/auth";
import { useRecoilValue } from "recoil";
import { authState } from "recoil/auth";

const Navbar = ({ type, menus }) => {
  const { logout } = useAuthActions();
  const navigate = useNavigate();
  const auth = useRecoilValue(authState);

  return (
    <div className="admin_menu">
      <div className="admin-logo text-align-center">
        <h1>
          <Link
            to="/admin/home"
            onClick={() => {
              navigate(0);
              // window.location.pathname === "/admin/home" &&
              //   window.location.reload();
            }}
          >
            <img src={process.env.PUBLIC_URL + "/img/admin/admin-logo.svg"} />
          </Link>
        </h1>
      </div>
      <div className="profile flex">
        <div className="user-profile flex">
          <div className="profile-img"></div>
          <div className="profile-name">
            <p className="grade">{type}</p>
            <p className="user-name">{auth?.user?.payload?.user_name}님</p>
          </div>
        </div>
        <div className="logout-box">
          <button onClick={() => logout()}>
            <img src={process.env.PUBLIC_URL + "/img/admin/logout.svg"} />
          </button>
        </div>
      </div>
      <div className="lnb">
        <ul>
          <li>
            {menus.map((menu, i) => {
              return (
                <Link
                  to={menu.link}
                  className={menu.className}
                  key={i}
                  onClick={() => {
                    menu.link === window.location.pathname &&
                      window.location.reload();
                  }}
                >
                  {menu.name}
                </Link>
              );
            })}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
